import { render, staticRenderFns } from "./RequestPayoutInstructions.vue?vue&type=template&id=d6f87b4c&lang=pug&"
import script from "./RequestPayoutInstructions.vue?vue&type=script&lang=js&"
export * from "./RequestPayoutInstructions.vue?vue&type=script&lang=js&"
import style0 from "./RequestPayoutInstructions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f87b4c')) {
      api.createRecord('d6f87b4c', component.options)
    } else {
      api.reload('d6f87b4c', component.options)
    }
    module.hot.accept("./RequestPayoutInstructions.vue?vue&type=template&id=d6f87b4c&lang=pug&", function () {
      api.rerender('d6f87b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RequestPayoutInstructions.vue"
export default component.exports